import axiosInstance from "./api_helper";

const commandeService = {
    list: async (query) => {
        const response = await axiosInstance.post(`/api/ventes/bon-commande/list`, JSON.stringify(query));
        return response.data;
    },
    add: async (commande) => {
        return await axiosInstance.post('/api/ventes/bon-commande', commande);
    },
    validerCommande: async (id) => {
        return await axiosInstance.post(`/api/ventes/bon-livraison/${id}`);
    },
    generatePdf : async (commande) => {
        const response = await axiosInstance.post(`/api/ventes/bon-commande/report`, commande, {
            responseType: 'arraybuffer',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    },
    delete: async (id) => {
        const response = await axiosInstance.delete(`/api/ventes/bon-commande/${id}`);
        return response.data;
    },
   
    update: async (id, commande) => {
        return await axiosInstance.put(`/api/ventes/bon-commande/${id}`, JSON.stringify(commande));
    },
}

export default commandeService;